import React, { Fragment } from "react";
import {
  Row,
  Label,
  Input,
  Alert,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../estilos.css";
import * as IoIcons from "react-icons/io";
import Pagination from "react-js-pagination";
import Moment from "moment";
import useCuarentena from "../../hooks/useCuarentena";
import EtiquetaRAC from "../reciba/EtiquetaRAC";

function Cuarentena() {
  const {
    ppalmacen,
    formType,
    color,
    aVisible,
    mensajeAlert,
    cargando,
    activeTab,
    searchBy,
    search,
    reciba,
    currentPage,
    recordPerPage,
    totalRecords,
    pageRange,
    mRecibas,
    inputList,
    modal2,
    pInspeccion,
    clicInspeccion,
    onDismiss,
    palmacen,
    toggle1,
    buscarpor,
    setSearch,
    onSearchFecha,
    handlePageChange,
    toggle2,
    onChangesCantidad,
    onChanges,
    aceptarInspeccion,
    onSearch,
    onChangescheckVUAP,
    fetchCuarentena,
    obtenerUltimaUbicaciont,
    cliclMostrar,
  } = useCuarentena();

  return (
    <>
      {ppalmacen === true && (
        <>
          <div className="conteiner2">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>
            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <img
                    width="150px"
                    alt="cargando"
                    src="assets/img/preloader.gif"
                  />
                </div>
              </Row>
            )}

            {formType === "Cuarentena" && (
              <Fragment>
                <Row className="ml-1 mr-1 margintop10px">
                  <div class="col-lg-7 col-md-9 col-sm-12 col-xs-12 text-left  margintopmobil20px">
                    <Label>
                      <h5>Busqueda por: </h5>
                    </Label>
                    <select
                      name="recibabusqueda"
                      className="ml-2"
                      onChange={buscarpor}
                    >
                      <option value="cliente">Cliente</option>
                      <option value="paking">Packing</option>
                      <option value="numero de parte">Número de parte</option>
                      <option value="lote">Lote</option>
                      <option value="fecha">Fecha</option>
                      <option value="serial">Serial</option>
                      <option value="serial BTI">Serial BTI</option>
                      <option value="id de reciba">ID de Reciba</option>
                      <option value="NCProduccion">No conforme - Producción</option>
                      <option value="NCIncoming">No conforme - Incoming</option>
                    </select>
                    {(searchBy != "NCProduccion" && searchBy != "NCIncoming") && (
                      <Input
                        type={searchBy !== "fecha" ? "text" : "date"}
                        placeholder={"Búsqueda por " + searchBy}
                        onChange={
                          searchBy !== "fecha"
                            ? (e) => setSearch(e.target.value)
                            : onSearchFecha
                        }
                        onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                        value={search}
                      />
                    )}
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 col-xs-12 text-left  margintop20px">
                    <button
                      className="cbutton btn-dark floatright  "
                      title="Recargar página"
                      onClick={() => {
                        fetchCuarentena();
                      }}
                    >
                      <IoIcons.IoMdRefresh /> Recargar{" "}
                    </button>
                  </div>
                </Row>
                <Label className="floatrightleft mr-3">
                  <input
                    type="checkbox"
                    name="VUAP"
                    onChange={onChangescheckVUAP}
                    className="ml-2"
                  />
                  Vista del último al primero
                </Label>
                <div className={reciba.length > 7 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                  " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                  <Table className="mb-2 scroll ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th className="minwidth80px">ID</Th>
                        <Th>Cliente</Th>
                        <Th className="minwidth80px">Fecha y hora de reciba</Th>
                        <Th>Estatus </Th>
                        <Th>Packing </Th>
                        <Th>Número de parte</Th>
                        <Th>Lote</Th>
                        <Th className="minwidth100px">Serial </Th>
                        <Th className="minwidth100px">Serial BTI </Th>
                        <Th>Cantidad</Th>
                        <Th>Última ubicación</Th>
                        <Th className="width30px"> Acciones </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {reciba.map((recibas, i) => (
                        <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                          <Td>{recibas.numero}</Td>
                          <Td>{recibas.cliente}</Td>
                          <Td className="margintopmobil20px">
                            {recibas.fechayHoraDeReciba}
                          </Td>
                          <Td className="margintopmobil20px">
                            {recibas.status}
                          </Td>
                          <Td className="margintopmobil20px">
                            {recibas.packing}
                          </Td>
                          <Td className="margintopmobil20px">
                            {recibas.numerodeParte}
                          </Td>
                          <Td className="margintopmobil20px">{recibas.lote}</Td>
                          <Td className="margintopmobil20px">
                            {recibas.serial}
                          </Td>
                          <Td className="margintopmobil20px">
                            {recibas.serialRecibaBTI}
                          </Td>
                          <Td className="margintopmobil20px">
                            {recibas.piezasenCuarentena}
                          </Td>
                          <Td className="margintopmobil20px">
                            {obtenerUltimaUbicaciont(recibas.ultimaUbicacion)}
                          </Td>
                          <Td className="margintopmobil40px">
                            <button
                              class="btn-info cbutton mt-1 ml-1"
                              onClick={() => cliclMostrar(recibas)}
                              title="Detalles de reciba"
                            >
                              {" "}
                              <IoIcons.IoIosListBox />{" "}
                            </button>
                            <button
                              className="cbutton btn-primary  mt-1 ml-1 "
                              title="Registrar inspección"
                              onClick={() => {
                                clicInspeccion(recibas);
                              }}
                            >
                              <IoIcons.IoMdSearch />
                            </button>
                            {/* onClick={() => { clicInspeccion(mrecuperacion); }} disabled={mrecuperacion.Inspeccionar} */}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </div>
                <div className="mt-3 mb-3">
                  Página {currentPage}, mostrando del{" "}
                  {recordPerPage * currentPage - recordPerPage + 1} al{" "}
                  {totalRecords < recordPerPage * currentPage
                    ? totalRecords
                    : recordPerPage * currentPage}{" "}
                  de {totalRecords} registros
                </div>
                {/*<div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 " style={{ marginTop: 20 }}>{JSON.stringify(recibaSinFiltro)}</div>*/}
                <Row>
                  <div className="col-lg-12 col-md-12 col-sm-12  ">
                    <div className="floatcenter">
                      <Pagination
                        itemClass="page-item" // add it for bootstrap 4
                        linkClass="page-link" // add it for bootstrap 4
                        activePage={currentPage}
                        itemsCountPerPage={recordPerPage}
                        totalItemsCount={totalRecords}
                        pageRangeDisplayed={pageRange}
                        onChange={handlePageChange}
                      />
                    </div>
                  </div>
                </Row>
                <Modal isOpen={modal2} size="lg" toggle={toggle2}>
                  <ModalHeader toggle={toggle2}>
                    Inspección del material
                  </ModalHeader>
                  <ModalBody>
                    <h4>Datos generales</h4>
                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                      <Table className=" mb-2 scroll ">
                        <Thead class="thead-secondary">
                          <Tr>
                            <Th className="minwidth100px">Cliente</Th>
                            <Th>Número de parte</Th>
                            <Th>Descripción</Th>
                            <Th>Serial</Th>
                            <Th className="minwidth100px">Serial BTI</Th>
                            <Th className="minwidth60p ">Piezas recibidas</Th>
                            <Th className="minwidth60p ">
                              Piezas pendientes en cuarentena
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          <Tr>
                            <Td>{pInspeccion.cliente}</Td>
                            <Td>{pInspeccion.numerodeParte}</Td>
                            <Td>{pInspeccion.descripcion}</Td>
                            <Td
                              className={
                                pInspeccion.descripcion
                                  ? ""
                                  : "margintopmobil20px"
                              }
                            >
                              {pInspeccion.serial}
                            </Td>
                            <Td>{pInspeccion.serialRecibaBTI}</Td>
                            <Td>
                              {pInspeccion.cantidadRecibida > 0
                                ? pInspeccion.cantidadRecibida
                                : ""}
                            </Td>
                            <Td>
                              {(pInspeccion.piezasenCuarentena
                                ? pInspeccion.piezasenCuarentena
                                : 0) -
                                (pInspeccion.piezasCtnaNAEmbarcar
                                  ? pInspeccion.piezasCtnaNAEmbarcar
                                  : 0) -
                                ((pInspeccion.piezasCtnaPintadas
                                  ? pInspeccion.piezasCtnaPintadas
                                  : 0) -
                                  (pInspeccion.PiezasENRecuperadas
                                    ? pInspeccion.PiezasENRecuperadas
                                    : 0))}
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </div>
                    <h4>Detalle</h4>
                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                      <Table className=" mb-2 scroll ">
                        <Thead class="thead-secondary">
                          <Tr>
                            <Th className="minwidth60p ">
                              Piezas totales en cuarentena
                            </Th>
                            <Th className="minwidth60p ">Piezas a recuperar</Th>
                            <Th className="minwidth60p ">Piezas recuperadas</Th>
                            <Th className="minwidth60p ">
                              Piezas no recuperadas
                            </Th>
                            <Th className="minwidth60p ">Piezas en almacén</Th>
                            <Th className="minwidth60p ">Piezas pintadas</Th>
                            <Th className="minwidth60p ">Piezas a embarcar</Th>
                            <Th className="minwidth60p ">Piezas embarcadas</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          <Tr>
                            <Td>
                              {pInspeccion.piezasenCuarentena > 0
                                ? pInspeccion.piezasenCuarentena
                                : ""}
                            </Td>
                            <Td>
                              {pInspeccion.PiezasCtnaRecuperacion > 0
                                ? pInspeccion.PiezasCtnaRecuperacion
                                : ""}
                            </Td>
                            <Td>
                              {pInspeccion.piezasCtnaRecuperadas > 0
                                ? pInspeccion.piezasCtnaRecuperadas
                                : ""}
                            </Td>
                            <Td>
                              {pInspeccion.piezasCtnaNRecuperadas > 0
                                ? pInspeccion.piezasCtnaNRecuperadas
                                : ""}
                            </Td>
                            <Td>
                              {pInspeccion.piezasenAlmacen > 0
                                ? pInspeccion.piezasenAlmacen
                                : ""}
                            </Td>
                            <Td>
                              {pInspeccion.piezasPintadas > 0
                                ? pInspeccion.piezasPintadas
                                : ""}
                            </Td>
                            <Td>
                              {(pInspeccion.piezasCtnaNAEmbarcar
                                ? pInspeccion.piezasCtnaNAEmbarcar
                                : 0) +
                                (pInspeccion.piezasAEmbarcar
                                  ? pInspeccion.piezasAEmbarcar
                                  : 0) >
                                0
                                ? (pInspeccion.piezasCtnaNAEmbarcar
                                  ? pInspeccion.piezasCtnaNAEmbarcar
                                  : 0) +
                                (pInspeccion.piezasAEmbarcar
                                  ? pInspeccion.piezasAEmbarcar
                                  : 0)
                                : ""}
                            </Td>
                            <Td className="margintopmobil40px marginbottommobil40px">
                              {(pInspeccion.piezasEmbarcadas
                                ? pInspeccion.piezasEmbarcadas
                                : 0) +
                                (pInspeccion.piezasCtnaEmbarcadas
                                  ? pInspeccion.piezasCtnaEmbarcadas
                                  : 0) >
                                0
                                ? (pInspeccion.piezasEmbarcadas
                                  ? pInspeccion.piezasEmbarcadas
                                  : 0) +
                                (pInspeccion.piezasCtnaEmbarcadas
                                  ? pInspeccion.piezasCtnaEmbarcadas
                                  : 0)
                                : ""}
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </div>
                    <Row>
                      {/*<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">
                                                <Label className="floatleft" >Piezas a Embarcar: </Label>
                                                <Input name="piezasEnInspeccionando" value={pInspeccion.piezasEnInspeccionando} onChange={e => onChangesCantidad(e)} />
                                            </div>*/}
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup>
                          <Label className="floatleft ">
                            Piezas para almacén:
                          </Label>
                          <Input
                            name="CAprobado"
                            value={pInspeccion.CAprobado}
                            onChange={(e) => onChangesCantidad(e)}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup>
                          <Label className="floatleft ">
                            Piezas para embarques:
                          </Label>
                          <Input
                            name="CNAprobado"
                            value={pInspeccion.CNAprobado}
                            onChange={(e) => onChangesCantidad(e)}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 margintop20px">
                        <FormGroup>
                          <Label className="floatleft ">
                            Piezas para Recuperación:{" "}
                            {/*pInspeccion.piezasEnRecuperando*/}
                          </Label>
                          <Input
                            name="piezasEnRecuperando"
                            value={pInspeccion.piezasEnRecuperando}
                            onChange={(e) => onChangesCantidad(e)}
                          />
                        </FormGroup>
                      </div>
                    </Row>
                    {pInspeccion.piezasEnRecuperando && (
                      <>
                        <Row>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="floatleft ">Defecto*:</Label>
                              <select
                                name="defecto"
                                className=" custom-select"
                                onChange={(e) => onChanges(e)}
                              >
                                <option
                                  value=""
                                  selected={
                                    pInspeccion.defecto == "" ? true : false
                                  }
                                >
                                  Elije una opción
                                </option>
                                <option
                                  value="Reyadura/Golpe"
                                  selected={
                                    pInspeccion.defecto == "Reyadura/Golpe"
                                      ? true
                                      : false
                                  }
                                >
                                  Reyadura/Golpe
                                </option>
                                <option
                                  value="Grumo/Impureza"
                                  selected={
                                    pInspeccion.defecto == "Grumo/Impureza"
                                      ? true
                                      : false
                                  }
                                >
                                  Grumo/Impureza
                                </option>
                                <option
                                  value="Falta escurriemiento"
                                  selected={
                                    pInspeccion.defecto ==
                                      "Falta escurriemiento"
                                      ? true
                                      : false
                                  }
                                >
                                  Falta escurriemiento
                                </option>
                                <option
                                  value="Falso contacto"
                                  selected={
                                    pInspeccion.defecto == "Falso contacto"
                                      ? true
                                      : false
                                  }
                                >
                                  Falso contacto
                                </option>
                                <option
                                  value="Pin hole"
                                  selected={
                                    pInspeccion.defecto == "Pin hole"
                                      ? true
                                      : false
                                  }
                                >
                                  Pin hole
                                </option>
                                <option
                                  value="Contaminacion"
                                  selected={
                                    pInspeccion.defecto == "Contaminacion"
                                      ? true
                                      : false
                                  }
                                >
                                  Contaminacion
                                </option>
                                <option
                                  value="Burbuja"
                                  selected={
                                    pInspeccion.defecto == "Burbuja"
                                      ? true
                                      : false
                                  }
                                >
                                  Burbuja
                                </option>
                                <option
                                  value="Falta pintura"
                                  selected={
                                    pInspeccion.defecto == "Falta pintura"
                                      ? true
                                      : false
                                  }
                                >
                                  Falta pintura
                                </option>
                                <option
                                  value="Oxido"
                                  selected={
                                    pInspeccion.defecto == "Oxido"
                                      ? true
                                      : false
                                  }
                                >
                                  Oxido
                                </option>
                                <option
                                  value="Dobles"
                                  selected={
                                    pInspeccion.defecto == "Dobles"
                                      ? true
                                      : false
                                  }
                                >
                                  Dobles
                                </option>
                                <option
                                  value="Cenizo"
                                  selected={
                                    pInspeccion.defecto == "Cenizo"
                                      ? true
                                      : false
                                  }
                                >
                                  Cenizo
                                </option>
                                <option
                                  value="Otro"
                                  selected={
                                    pInspeccion.defecto == "Otro" ? true : false
                                  }
                                >
                                  Otro
                                </option>
                              </select>
                            </FormGroup>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="floatleft ">
                                Método de recuperación*:
                              </Label>
                              <select
                                name="mRecuperacion"
                                className=" custom-select"
                                onChange={(e) => onChanges(e)}
                              >
                                <option
                                  value=""
                                  selected={
                                    pInspeccion.defecto == "" ? true : false
                                  }
                                >
                                  Elije una opción
                                </option>
                                <option
                                  value="Spray"
                                  selected={
                                    pInspeccion.mRecuperacion == "Spray"
                                      ? true
                                      : false
                                  }
                                >
                                  Spray
                                </option>
                                <option
                                  value="Pistola"
                                  selected={
                                    pInspeccion.mRecuperacion == "Pistola"
                                      ? true
                                      : false
                                  }
                                >
                                  Pistola
                                </option>
                                <option
                                  value="Decapado"
                                  selected={
                                    pInspeccion.mRecuperacion == "Decapado"
                                      ? true
                                      : false
                                  }
                                >
                                  Decapado
                                </option>
                                <option
                                  value="Desoxidado"
                                  selected={
                                    pInspeccion.mRecuperacion == "Desoxidado"
                                      ? true
                                      : false
                                  }
                                >
                                  Desoxidado
                                </option>
                                <option
                                  value="Enderezar  piezas"
                                  selected={
                                    pInspeccion.mRecuperacion ==
                                      "Enderezar  piezas"
                                      ? true
                                      : false
                                  }
                                >
                                  Enderezar piezas
                                </option>
                                <option
                                  value="Desengrase o limpieza"
                                  selected={
                                    pInspeccion.mRecuperacion ==
                                      "Desengrase o limpieza"
                                      ? true
                                      : false
                                  }
                                >
                                  Desengrase o limpieza
                                </option>
                                <option
                                  value="Otro"
                                  selected={
                                    pInspeccion.mRecuperacion == "7"
                                      ? true
                                      : false
                                  }
                                >
                                  Otro
                                </option>
                              </select>
                            </FormGroup>
                          </div>
                        </Row>
                        <Row>
                          {pInspeccion.defecto === "Otro" && (
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                              <Label className="floatleft">
                                Otro defecto*:{" "}
                              </Label>
                              <Input
                                name="otroDefecto"
                                onChange={(e) => onChanges(e)}
                              />
                            </div>
                          )}
                          {pInspeccion.mRecuperacion === "Otro" && (
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                              <FormGroup>
                                <Label className="floatleft ">
                                  Otro método de recuperación*:
                                </Label>
                                <Input
                                  name="otroMRecuperacion"
                                  onChange={(e) => onChanges(e)}
                                />
                              </FormGroup>
                            </div>
                          )}
                        </Row>
                      </>
                    )}
                    <Row>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <FormGroup>
                          <Label className="floatleft ">Comentarios:</Label>
                          <Input
                            type="textarea"
                            rows="2"
                            name="comentariosdecuarentena"
                            onChange={(e) => onChanges(e)}
                          />
                        </FormGroup>
                      </div>
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    {/*pInspeccion.piezasEnRecuperando*/}
                    <Button color="primary" onClick={aceptarInspeccion}>
                      Aceptar
                    </Button>{" "}
                    <Button color="danger" onClick={toggle2}>
                      Cancelar
                    </Button>
                  </ModalFooter>
                </Modal>
              </Fragment>
            )}
          </div>
          <div className="conteiner2">
            {formType === "Detalle Reciba " + mRecibas.numero && (
              <Fragment>
                <Row>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatleft"></div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatright">
                      <button
                        class="btn-info cbutton floatright"
                        onClick={palmacen}
                        title="Regresar"
                      >
                        <IoIcons.IoMdArrowRoundBack />
                        Regresar{" "}
                      </button>
                    </div>
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px scroll">
                    <div className="textaligmentleft">
                      {" "}
                      <h5>Datos generales</h5>
                    </div>
                    <Table className="margintop20px mb-2  ">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>ID</Th>
                          <Th>Cliente</Th>
                          <Th className="minwidth80px">
                            Fecha y hora de reciba
                          </Th>
                          <Th>Cantidad por reciba</Th>
                          <Th>Status</Th>
                          <Th> Quien Inspeccionó </Th>
                          <Th> Comentarios de inspección </Th>
                          <Th> PO </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td>{mRecibas.numero}</Td>
                          <Td>{mRecibas.cliente}</Td>
                          <Td className="margintopmobil20px">
                            {Moment(mRecibas.fechaDeReciba).format(
                              "DD/MM/YYYY"
                            ) +
                              " " +
                              mRecibas.horaDeReciba}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.cantidadRecibida}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.status}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.quienInspecciono}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.comentarios}
                          </Td>
                          <Td className="margintopmobil20px">{mRecibas.po}</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll margintop20px">
                    <div className="textaligmentleft">
                      {" "}
                      <h5>Detalle</h5>{" "}
                    </div>
                    <Table className=" mb-2">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>
                            {" "}
                            {mRecibas.cliente ===
                              "Olson Internacional, S. de R.l. de C.v"
                              ? "Line"
                              : "Packing"}
                          </Th>
                          <Th>Número de parte</Th>
                          <Th>Descripción</Th>
                          <Th>Material en</Th>
                          <Th>Empaques</Th>
                          <Th>Lote</Th>
                          <Th>Serial</Th>
                          <Th>Serial BTI</Th>
                          <Th>Cantidad por serial</Th>
                          <Th>Estatus</Th>
                          <Th>Última ubicación</Th>
                          <Th>Quién Inspeccionó</Th>
                          <Th>Comentarios</Th>
                          <Th>Imprimir Etiqueta</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {inputList.map((x, i) => {
                          return (
                            x.activo && (
                              <Tr class={x.sombreado ? "table-primary" : ""}>
                                <Td className="margintopmobil20px">
                                  {x.packing}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.numerodeParte}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.descripcion}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEn}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEnCantidad}
                                </Td>
                                <Td className="margintopmobil20px">{x.lote}</Td>
                                <Td className="margintopmobil20px">
                                  {x.serial}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.serialRecibaBTI}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.cantidadRecibida}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.status}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {obtenerUltimaUbicaciont(x.ultimaUbicacion)}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.quienInspecciono}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.comentariosdeinspeccion}
                                </Td>
                                <Td>
                                  {(x.piezasenCuarentena
                                    ? x.piezasenCuarentena
                                    : 0) > 0 && (
                                      <EtiquetaRAC
                                        indice={i}
                                        inputList={inputList}
                                        mRecibas={mRecibas}
                                        tipo={"parcial"}
                                        bColor={"dark mt-1 ml-1"}
                                        btitle={"Etiqueta viajera - Cuarentena"}
                                        llamada={"Cuarentena"}
                                      />
                                    )}
                                </Td>
                              </Tr>
                            )
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                  {/*<div  className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 " style={{ marginTop: 20 }}>{JSON.stringify(inputListUbicaciones)}</div>*/}
                </Row>
              </Fragment>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Cuarentena;
